import React from "react";
import Layout from "../layout";
import HeroSimple from "../Components/home/HeroSimple";
import FeaturesSimple from "../Components/home/FeaturesSimple";
import TechSimple from "../Components/home/TechSimple";
import CTA from "../Components/home/CTA";

export default function HomeSimple() {
  return (
    <Layout currentPageName="Home">
      <div>
        {/* Notice Banner */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white py-3 px-4 text-center">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <p className="text-sm font-medium">
              ⚠️ SIMPLIFIED TEST PAGE - Based on Cactus design. Your original is safe!
            </p>
            <a 
              href="/" 
              className="text-sm underline hover:no-underline font-semibold"
            >
              Go Back →
            </a>
          </div>
        </div>
        <HeroSimple />
        <FeaturesSimple />
        <TechSimple />
        <CTA />
      </div>
    </Layout>
  );
}


